import { render } from "./create.vue?vue&type=template&id=4fbb5bf9"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/tester_types/create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4fbb5bf9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fbb5bf9', __exports__)) {
    console.log('reload')
    api.reload('4fbb5bf9', __exports__)
  }
  
  module.hot.accept("./create.vue?vue&type=template&id=4fbb5bf9", () => {
    console.log('re-render')
    api.rerender('4fbb5bf9', render)
  })

}


export default __exports__